import script from "./experimentPage.vue?vue&type=script&setup=true&lang=js"
export * from "./experimentPage.vue?vue&type=script&setup=true&lang=js"

import "./experimentPage.vue?vue&type=style&index=0&id=76335e9c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76335e9c"]])

export default __exports__